<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'book',
  data () {
    return {

    }
  },
  created () {
    if (!this.selectBook && this.$route.path.indexOf('cover') < 0) {
      console.log('book::created')
      var self = this
      this.$store.dispatch('Books/get', {'id': this.$route.params.id}).then(function (response) {
        if (!response.result) {
          self.$router.push('/books')
          self.errorMessage(response.message)
        }
      })
    }
  },
  destroyed () {
    console.log('book::destroyed')
    this.$store.dispatch('Books/clear')
    this.$store.dispatch('Chapters/clear')
    this.$store.dispatch('Bodies/clear')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Book.vue